export default __webpack_public_path__ + "img/antwerp tera.056e918d.jpg";